import { Skeleton } from "boneyard-js/react";

// Skeleton row that mirrors the visible-card count of <SwipperMultiple>
// at every breakpoint:
//   <992px   → 1 card  (matches SwipperMultiple.breakpoints[320|480|640])
//   992-1199 → 2 cards (matches breakpoints[992])
//   ≥1200px  → 3 cards (matches breakpoints[1200])
// Achieved by always rendering 3 placeholders inside the same column
// classes the swiper would use, then hiding the extras with Bootstrap's
// d-none / d-lg-block / d-xl-block utilities. Keeping the placeholder
// count in lock-step with the loaded swiper avoids the layout jump
// users were seeing (4-card grid → 3-card swiper).
const SLOT_VISIBILITY = ["", "d-none d-lg-block", "d-none d-xl-block"];

const ArtworkCardSkeletonRow: React.FC = () => (
  <div className="row">
    {SLOT_VISIBILITY.map((vis, i) => (
      <div
        className={`col-12 col-lg-6 col-xl-4 mb-3${vis ? ` ${vis}` : ""}`}
        key={i}
      >
        <Skeleton name="artwork-card" loading={true}>
          <span style={{ display: "block", aspectRatio: "3 / 4" }} />
        </Skeleton>
      </div>
    ))}
  </div>
);

export default ArtworkCardSkeletonRow;
